import { IShippingContact } from 'app/pages/frames/components/Form/FormShipping/interface';
import { useCreditCardSubtmitOrder } from 'app/pages/frames/hooks/creditCardSubmitOrder';
import { PaymentMethodType } from 'app/util/constants';
import { useState } from 'react';
import { parseShippingFormDataForEndpoint } from '../components/Form/FormShipping/helpers';
import { useErrorStore } from 'app/context/errorStore';
import { useCheckoutFrameStore } from 'app/context/checkoutStore';
import { useSearchParams } from 'react-router-dom';

export const useCardOrder = () => {
  const { setError } = useErrorStore();
  const [confirmationShippingContact, setConfirmationShippingContact] = useState<any>(false);
  const [initialTime] = useState(new Date());

  const { checkoutRequest } = useCheckoutFrameStore();
  const {
    needsShippingContact = false,
    recurrent: isRecurrent = false,
    tokenId,
    shippingContact,
    id: checkoutRequestId,
  } = checkoutRequest || {};

  const { doPost, orderWithPaymentSource } = useCreditCardSubtmitOrder();
  const [searchParams] = useSearchParams();
  const savedCard = searchParams.get('savedCard') === 'true';

  const onSubmit = async () => {
    try {
      if (needsShippingContact && !shippingContact) {
        return;
      }

      const customBody = {
        checkoutRequestId,
        paymentMethod: PaymentMethodType.Card,
        tokenID: tokenId,
        shippingContact,
        savedCard,
      };
      if (needsShippingContact && customBody.shippingContact) {
        const shippingContactTemp: IShippingContact = parseShippingFormDataForEndpoint(customBody.shippingContact);
        customBody.shippingContact = { ...shippingContactTemp };
        setConfirmationShippingContact(shippingContact);
      }

      await doPost({
        paymentRequestData: customBody,
        initialTime,
      });
    } catch (e: any) {
      setError(e);
    }
  };
  return {
    start3DSFlow: onSubmit,
    data: {
      ...orderWithPaymentSource,
      confirmationShippingContact,
    },
    isRecurrent,
  };
};
